export default class EventTracker {
  constructor() {
  }

  play({ id, name, affiliation, type }) {
    // Google Universal Analytics Event
    const ua = {
      category: "Music",
      action: 'Play',
      label: `${name} (${this.capitalize(type)})`
    };

    // Google Analytics 4 Event
    // Event Doc: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#select_item
    const ga4 = {
      event: "select_item",
      params: {
        items: [
          {
            item_id: id,
            item_name: name, // Name or ID is required.
            affiliation: affiliation,
            item_category: this.normalizeType(type), // E.g Beats
          }
        ]
      }
    };

    this.sendEvent(ua, ga4)
  }

  checkout({ items, total, coupon }) {
    // Google Universal Analytics Event
    const ua = {
      category: "Sales",
      action: "Checkout",
      label: items.map(item => item.name).join(', ')
    };

    // Google Analytics 4 Event
    // Event Doc: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#begin_checkout
    const ga4 = {
      event: "begin_checkout",
      params: {
        currency: "USD",
        value: total,
        coupon,
        items: items.map(({ id, name, affiliation, type, license, price, discount }) => {
          return {
            item_id: id,
            item_name: name,
            affiliation,
            item_category: this.normalizeType(type),
            item_variant: license,
            price,
            discount
          };
        })
      }
    };

    this.sendEvent(ua, ga4);
  }

  addToCart({ id, name, affiliation, type, license }) {
    // Google Universal Analytics Event
    const ua = {
      category: "Sales",
      action: "Add To Cart",
      label: license ? `${name} (${license})` : name
    };

    // Google Analytics 4 Event
    // Event Doc: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#add_to_cart
    const ga4 = {
      event: "add_to_cart",
      params: {
        items: [
          {
            item_id: id,
            item_name: name,
            item_category: this.normalizeType(type),
            item_variant: license,
            affiliation
          }
        ]
      }
    };

    this.sendEvent(ua, ga4);
  }

  applyCoupon(coupon) {
    // Google Universal Analytics Event
    const ua = {
      category: "Sales",
      action: "Coupon Applied",
      label: coupon
    };

    // Google Analytics 4 Event
    // This is a custom ga4 event (not recommended)
    const ga4 = {
      event: 'coupon_applied',
      params: {
        coupon: coupon
      }
    }

    this.sendEvent(ua, ga4);
  }

  share({ id, name, type, socialAccount}) {
    // Google Universal Analytics Event
    const ua = {
      category: "Sales",
      action: "Share",
      label: `${name} (${socialAccount})`
    };

    // Google Analytics 4 Event
    // Event Doc: https://developers.google.com/analytics/devguides/collection/ga4/reference/events#share
    const ga4 = {
      event: "share",
      params: {
        item_id: id,
        content_type: type,
        method: socialAccount
      }
    };

    this.sendEvent(ua, ga4);
  }

  identify({id, name}) {
    this.pushToDataLayer({
      event: 'identity',
      identity: {
        id,
        name
      }
    })
  }

  capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  normalizeType(type) {
    if (!type) return

    const map = {
      soundkit: 'Sound Packs',
      beat: 'Beats',
      song: 'Songs',
      album: 'Albums'
    }

    return map[type] ?? `${this.capitalize(type)}s`
  }

  sendEvent(uaEvent, ga4Event) {
    // Cleanup to prevent multiple ga4 events on a page from affecting each other.
    this.pushToDataLayer({ ga4Event: null })
    this.pushToDataLayer({
      event: uaEvent.action,
      store_event_category: uaEvent.category,
      store_event_action: uaEvent.action,
      store_event_label: uaEvent.label,
      ga4Event
    })
  }

  pushToDataLayer(event) {
    if (window.dataLayer) {
      window.dataLayer.push(event)
    }
  }
}
